import React, { Component } from 'react'
import { Card, Col, Row, Form, Button, Table } from "react-bootstrap-v5";
import { toast } from "react-toastify";
// import moment from "moment";
import ReactToPrint from "react-to-print";
import { reportService } from '../../Services/reportService'
import { retailerService } from '../../Services/retailerService'
import {Spinner} from 'react-bootstrap-v5';

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

class RetailerIncentive extends Component {

    state = {
        reportObj: [],
        retailersObj: [],
        startDate: "",
        loader:false,
        endDate: "",
        referral_token: "",
        retailer_name: ""
    }

    componentDidMount() {
        this.componentRef = React.createRef();
        this.getPerformanceReportData()
        this.getRetailers()
    }

    getRetailers = () => {
        retailerService.getAllRetailer().then(result => {
            if (result.status === true) {
                this.setState({ retailersObj: result.data })
            }
        })
    }

    getPerformanceReportData = (params = {item : 435}) => {
        this.setState({loader:true})
        reportService.getPerformanceReort(params).then(result => {
            if (result.status === true) {
                this.setState({ reportObj: result.data,loader:false })
            } else {
                // Something went wrong
            }
            this.setState({loader:false})
        })
    }

    exportToExcel = () => {
        let params = { startDate: this.state.startDate, endDate: this.state.endDate, retailer_name: this.state.retailer_name }
        reportService.exportPerformanceReort(params).then(result => {
            if (result.status === true) {
                window.location.href = REACT_APP_API_BASEURL + "/" + result.data;
            } else {
                toast.error("Something went wrong")
            }
        })
    }

    // handleModeChange = (mode) => {
    //     this.setState({referral_token: mode},()=>{
    //         let search = {startDate: this.state.startDate, endDate: this.state.endDate,referral_token: this.state.referral_token}
    //          console.log("incen",search);
    //         this.getPerformanceReportData(search)
    //     })
    // }

    handleInputChange = (e) => {
        let search = { startDate: this.state.startDate, endDate: this.state.endDate, retailer_name: e.target.value }
        this.getPerformanceReportData(search)
        this.setState({ retailer_name: e.target.value })
    }

    // handleDateChange = (e) => {
    //     const { name, value } = e.target

    //     let setdate = name === 'start_date' ? 'startDate' : 'endDate'
    //     this.setState({[setdate] : new Date(value).getTime()}, () => {
    //         if(this.state.startDate !== '' && this.state.endDate !== ""){
    //             let search = {startDate: this.state.startDate, endDate: this.state.endDate,referral_token: this.state.referral_token}
    //             this.getPerformanceReportData(search)
    //         }
    //     })
    // }

    //date selection function //neha

    handleDateChange = (e) => {
        const { name, value } = e.target;
        let setdate = name === "start_date" ? "startDate" : "endDate";

        const selectedDate = new Date(value).getTime();
        this.setState({ [setdate]: selectedDate }, () => {
            const { startDate, endDate } = this.state;

            if (startDate !== "" && endDate !== "") {
                if (startDate > endDate) {
                    this.setState({ startDate: "", endDate: "" });
                    toast.info("Start date cannot be greater than end date.");

                } else {
                    let search = { startDate: this.state.startDate, endDate: this.state.endDate, retailer_name: this.state.retailer_name }
                    console.log("incen", search);
                    this.getPerformanceReportData(search)
                }
            }
        });
    };

    getPercent = (value, percent) => {
        return (Number(value) * Number(percent) / 100)
    }

    render() {
        const { reportObj, retailersObj } = this.state
        // let revTotal = 0, costTotal = 0, profitTotal = 0;
        let sno = 0
        return (
            <Card>
                <div className="card-header bg-light"><h4>Retailer Incentive</h4></div>
                <Card.Body>
                    <Row className="mb-3">
                        <Col md={3} className="mb-3">
                            {/* <Form.Label>Retailer</Form.Label>
                            <Form.Select name="retailer" onChange={(e) => this.handleModeChange(e.target.value)}>
                                <option value="">All Retailer</option>
                                {
                                    retailersObj.length
                                    && retailersObj.map(item => <option value={item.retailer_name}>
                                        {item.retailer_name}</option>)
                                }
                            </Form.Select> */}
                            <Form.Label>Search</Form.Label>
                            <Form.Control
                                type="text"
                                name="search"
                                placeholder='Search Retailer'
                                onChange={(e) => this.handleInputChange(e)}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Label>Start Date</Form.Label>
                            <Form.Control
                                type="date"
                                name="start_date"
                                max={new Date().toISOString().split('T')[0]}
                                onChange={(e) => this.handleDateChange(e)}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Label>End Date</Form.Label>
                            <Form.Control
                                type="date"
                                name="end_date"
                                max={new Date().toISOString().split('T')[0]}
                                onChange={(e) => this.handleDateChange(e)}
                            />
                        </Col>
                        <Col md={3} className="mt-3">
                            <div className='d-flex justify-content-end'>
                                <Button className='me-3 ps-4 pe-4' variant="success" onClick={() => this.exportToExcel()}> Excel </Button>
                                <ReactToPrint
                                    trigger={() => {
                                        return <Button variant="secondary" className='ps-4 pe-4' >Print</Button>;
                                    }}
                                    content={() => this.componentRef}
                                    bodyClass={"printElement"}
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row className='printElement' ref={el => (this.componentRef = el)}>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Job Number</th>
                                    <th>Retailer</th>
                                    <th>Tariff Amount</th>
                                    <th>Total Incentive(%)</th>
                                    <th>Retailer Incentive(%)</th>
                                    <th>Customer Incentive(%)</th>
                                    <th>Customer Amount (After Disc.)</th>
                                    <th>Customer Agreed Amount</th>
                                    <th>Actual Incentive Retailer Payout</th>
                                    <th>Incentive Paid Status</th>
                                    <th>Value of Goods</th>
                                    <th>Retailer Invoice No.</th>
                                    <th>Shipment Status</th>
                                </tr>
                            </thead>
                                    {this.state.loader &&
                                    <tbody>
                                        <tr>
                                            <td colSpan={20} className='text-center'>
                                        <Spinner animation="border" />
                                            </td>
                                        </tr>
                                    </tbody> 
                                  ||
                            <tbody>
                                {

                                    reportObj.length
                                    && reportObj.map((item, index) => {
                                        let retailerToken = '';
                                        let retailerNm = '';
                                        if (item.general_details?.sales_person) {
                                            retailerToken = item.general_details?.sales_person ? item.general_details.sales_person?.referral_token : ''
                                            retailerNm =  item.general_details?.sales_person.retailer_name;
                                        } else {
                                            retailerToken = item.general_details?.referral_token ? item.general_details?.referral_token :  item.general_details?.referral_code
                                            retailerNm =  item.general_details?.referral_code;
                                        }

                                        let retailerName = item?.general_details?.sales_person?.retailer_name 
                                        ? item.general_details.sales_person.retailer_name
                                        : item?.general_details?.retailer_name
                                         ? item.general_details.retailer_name
                                         : ''

                                        if (!retailerToken) {
                                            return null;
                                        } else {

                                            // let retailerName = item.general_details.sales_person ? item.general_details.sales_person.retailer_name : ''

                                            let acutalAmt = item.payment_information ? item.payment_information.actual_amount : 0
                                            let agreedAmt = item.payment_information ? item.payment_information.agreed_amount : 0
                                            if(item.payment_information && item.payment_information?.other_amount){
                                                agreedAmt = 0
                                            }
                                           

                                            let totalDiscount = item.general_details?.sales_person ? item.general_details?.sales_person?.total_discount ? item.general_details.sales_person.total_discount : 0 : 0
                                            let retailerDiscount = item.general_details?.sales_person ? item.general_details?.sales_person?.store_discount ? item.general_details.sales_person.store_discount : 0 : 0
                                            let customerDiscount = item.general_details?.sales_person ? item.general_details?.sales_person?.customer_discount ? item.general_details.sales_person.customer_discount : 0 : 0

                                            let retailerInfo = item?.retailer_info;
                                         
                                            if(!totalDiscount &&retailerInfo){
                                                totalDiscount = retailerInfo.total_discount;
                                                retailerDiscount = retailerInfo.store_discount;
                                                customerDiscount = retailerInfo.customer_discount;
 
                                            }
                                          
                                            let totalIncentive = totalDiscount !== 0 ? this.getPercent(acutalAmt, totalDiscount) : 0
                                            let retailerIncentive = retailerDiscount !== 0 ? this.getPercent(acutalAmt, retailerDiscount) : 0
                                            let customerIncentive = totalDiscount !== 0 ? this.getPercent(acutalAmt, customerDiscount) : 0
                                            if (!acutalAmt) { acutalAmt = 0; }
                                            if (!agreedAmt) { agreedAmt = 0; }
                                            let retailerPayout =0;
                                            let finalCust =  (acutalAmt - customerIncentive).toFixed(2)
                                            if(finalCust==agreedAmt.toFixed(2)){
                                                retailerPayout = retailerIncentive;
                                            }else{
                                               let amtDiff =  (finalCust -agreedAmt).toFixed(2);
                                               retailerPayout = (retailerIncentive -amtDiff).toFixed(2);
                                               if(retailerPayout<0){retailerPayout=0}
                                            }
                                           // (acutalAmt - retailerIncentive).toFixed(2)
                                            return <tr>
                                                <td>{++sno}</td>
                                                <td>{item.job_token}</td>
                                                <td>{retailerName}</td>
                                                <td>{Number(acutalAmt).toFixed(2)}</td>
                                                <td>{totalIncentive.toFixed(2)}</td>
                                                <td>{retailerIncentive.toFixed(2)}</td>
                                                <td>{customerIncentive.toFixed(2)}</td>
                                                <td>{(acutalAmt - customerIncentive).toFixed(2)}</td>
                                                <td>{agreedAmt.toFixed(2)}</td>
                                                <td> { retailerPayout} </td>
                                                <td>{item.retailer_details.length ? item.retailer_details[0]?.invoice_payout_status : "NA"}</td>
                                                <td>{item.retailer_details.length ? item.retailer_details[0]?.invoice_value : "NA"}</td>
                                                <td>{item.retailer_details.length ? item.retailer_details[0]?.invoice_number : "NA"}</td>
                                                <td>{item.job_status || "NA"}</td>
                                            </tr>
                                        }

                                    }) || <tr><td colSpan={20} className='text-center'>
                                        Data Not Available</td></tr>

                                }
                            </tbody>
                                    }
                        </Table>
                    </Row>
                </Card.Body>
            </Card>
        )
    }
}

export { RetailerIncentive }
